"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.someSeries = exports.someLimit = exports.some = exports.reduce = exports.mapSeries = exports.mapLimit = exports.map = exports.forEachOfSeries = exports.forEachOfLimit = exports.forEachOf = exports.forEachSeries = exports.forEachLimit = exports.forEach = exports.findSeries = exports.findLimit = exports.find = exports.filterSeries = exports.filterLimit = exports.filter = exports.everySeries = exports.everyLimit = exports.every = void 0;
/* eslint-disable new-cap */
const IterableMethods = __importStar(require("./asyncIterationHandlers"));
exports.every = new IterableMethods.every();
exports.everyLimit = new IterableMethods.everyLimit();
exports.everySeries = new IterableMethods.everySeries();
exports.filter = new IterableMethods.filter();
exports.filterLimit = new IterableMethods.filterLimit();
exports.filterSeries = new IterableMethods.filterSeries();
exports.find = new IterableMethods.find();
exports.findLimit = new IterableMethods.findLimit();
exports.findSeries = new IterableMethods.findSeries();
exports.forEach = new IterableMethods.forEach();
exports.forEachLimit = new IterableMethods.forEachLimit();
exports.forEachSeries = new IterableMethods.forEachSeries();
exports.forEachOf = new IterableMethods.forEachOf();
exports.forEachOfLimit = new IterableMethods.forEachOfLimit();
exports.forEachOfSeries = new IterableMethods.forEachOfSeries();
exports.map = new IterableMethods.map();
exports.mapLimit = new IterableMethods.mapLimit();
exports.mapSeries = new IterableMethods.mapSeries();
exports.reduce = new IterableMethods.reduce();
// Note: Currently disabled due to poor handling of async iterators
// see commented out tests around this
// export const reduceRight = new IterableMethods.reduceRight();
// export const reject = new IterableMethods.reject();
// export const rejectLimit = new IterableMethods.rejectLimit();
// export const rejectSeries = new IterableMethods.rejectSeries();
exports.some = new IterableMethods.some();
exports.someLimit = new IterableMethods.someLimit();
exports.someSeries = new IterableMethods.someSeries();
// export const transform = new IterableMethods.transform();
